import { Replay } from '@mui/icons-material';
import {
  Box,
  Button,
  Typography
} from '@mui/material';



export type StyledFormDisplayFieldProps = {
  label: string;
  value: string;
};

export const FC = (props: StyledFormDisplayFieldProps) => {

  if (props.label.toLowerCase().trim() !== 'password') {
    return (
      <Box
        display='flex'
        flexDirection='column'
        rowGap='.5rem'
        paddingBottom='1.5rem'
      >
        <Typography variant='formLabel'>{props.label}</Typography>
        <Typography variant='tabSectionTextRegular'>{props.value}</Typography>
      </Box>
    );
  } else {
    return (
      <Box
        display='flex'
        flexDirection='column'
        rowGap='.5rem'
        paddingBottom='1.5rem'
      >
        <Typography variant='formLabel'>{props.label}</Typography>
        <Button
          startIcon={<Replay />}
          variant='text'
          color='error'
        >Reset Password
        </Button>
      </Box>
    );
  }
};
